/**
 * ==========================================================
 * V-Hydra Product Builder
 * Version 3.0
 * PARTE 1/8
 * ==========================================================
 */

(() => {

'use strict';

/* ==========================================================
   CONFIG
========================================================== */

const CONFIG = {

    FREE_SHIPPING_QTY: 2,

    CURRENCY: 'BRL',

    LOCALE: 'pt-BR',

    CART_URL: '/cart/add.js',

    CART_DRAWER: false

};

/* ==========================================================
   BUILDER
========================================================== */

class VHydraBuilder {

    constructor(container){

        this.container = container;

        this.state = {

            items:{},

            quantity:0,

            subtotal:0,

            freeShipping:false

        };

        this.cacheDOM();

        this.bindEvents();

        this.render();

        console.log('💜 V-Hydra Builder iniciado');

    }

    /* ==========================================================
       CACHE
    ========================================================== */

    cacheDOM(){

        this.cards = [
            ...this.container.querySelectorAll('.vhb-card')
        ];

        this.summary =
            this.container.querySelector('.vhb-summary');

        this.summaryItems =
            document.getElementById('vhb-summary-items');

        this.totalItems =
            document.getElementById('vhb-total-items');

        this.totalPrice =
            document.getElementById('vhb-total-price');

        this.shippingMessage =
            document.getElementById('vhb-shipping-message');

        this.cartButton =
            document.getElementById('vhb-add-cart');

    }

    /* ==========================================================
       HELPERS
    ========================================================== */

    formatMoney(value){

        return new Intl.NumberFormat(

            CONFIG.LOCALE,

            {

                style:'currency',

                currency:CONFIG.CURRENCY

            }

        ).format(value / 100);

    }

    getItem(id){

        return this.state.items[id] || null;

    }

    hasItem(id){

        return !!this.state.items[id];

    }

    createItem(card){

        return{

            id:card.dataset.variantId,

            productId:card.dataset.productId,

            title:card.dataset.title,

            handle:card.dataset.handle,

            quantity:1,

            price:Number(card.dataset.price),

            card

        };

    }

    /* ==========================================================
       EVENTS
    ========================================================== */

    bindEvents(){

        this.cards.forEach(card=>{

            const addButton =
                card.querySelector('.vhb-card__button');

            const plusButton =
                card.querySelector('.vhb-card__plus');

            const minusButton =
                card.querySelector('.vhb-card__minus');

            if(addButton){

                addButton.addEventListener(

                    'click',

                    ()=>this.add(card)

                );

            }

            if(plusButton){

                plusButton.addEventListener(

                    'click',

                    ()=>this.plus(card)

                );

            }

            if(minusButton){

                minusButton.addEventListener(

                    'click',

                    ()=>this.minus(card)

                );

            }

        });

        if(this.cartButton){

            this.cartButton.addEventListener(

                'click',

                ()=>this.addToCart()

            );

        }

    }
        /* ==========================================================
       ADD
    ========================================================== */

    add(card){

        const id = card.dataset.variantId;

        if(this.hasItem(id)){

            this.plus(card);

            return;

        }

        this.state.items[id] = this.createItem(card);

        this.updateState();

    }

    /* ==========================================================
       PLUS
    ========================================================== */

    plus(card){

        const id = card.dataset.variantId;

        const item = this.getItem(id);

        if(!item) return;

        item.quantity++;
        card.querySelector('.vhb-card__count')
    ?.classList.remove('vhb-total--pulse');

requestAnimationFrame(()=>{

    card.querySelector('.vhb-card__count')
        ?.classList.add('vhb-total--pulse');

});

        this.updateState();

    }

    /* ==========================================================
       MINUS
    ========================================================== */

    minus(card){

        const id = card.dataset.variantId;

        const item = this.getItem(id);

        if(!item) return;

        item.quantity--;
        card.querySelector('.vhb-card__count')
    ?.classList.remove('vhb-total--pulse');

requestAnimationFrame(()=>{

    card.querySelector('.vhb-card__count')
        ?.classList.add('vhb-total--pulse');

});

        if(item.quantity <= 0){

            delete this.state.items[id];

        }

        this.updateState();

    }

    /* ==========================================================
       UPDATE STATE
    ========================================================== */

    updateState(){

        let quantity = 0;

        let subtotal = 0;

        Object.values(this.state.items).forEach(item=>{

            quantity += item.quantity;

            subtotal += item.quantity * item.price;

        });

        this.state.quantity = quantity;

        this.state.subtotal = subtotal;

        this.state.freeShipping =
            quantity >= CONFIG.FREE_SHIPPING_QTY;

        this.render();
        document.dispatchEvent(
    new CustomEvent("vhb:stateChanged",{
        detail:{
            quantity:this.state.quantity,
            subtotal:this.state.subtotal,
            freeShipping:this.state.freeShipping
        }
    })
);
        this.debug();

    }

    /* ==========================================================
       RENDER
    ========================================================== */

    
    /* ==========================================================
       RENDER CARDS
    ========================================================== */

    renderCards(){

        this.cards.forEach(card=>{

            const id = card.dataset.variantId;

            const item = this.getItem(id);

            const addButton =
                card.querySelector('.vhb-card__button');

            const quantityBox =
                card.querySelector('.vhb-card__quantity');

            const counter =
                card.querySelector('.vhb-card__count');

            if(item){

                addButton.hidden = true;

                quantityBox.hidden = false;

                counter.textContent = item.quantity;

                card.classList.add('is-selected');

            }else{

                addButton.hidden = false;

                quantityBox.hidden = true;

                counter.textContent = 1;

                card.classList.remove('is-selected');

            }

        });

    }
        /* ==========================================================
       RENDER SUMMARY
    ========================================================== */

    renderSummary(){

        if(this.summaryItems){

            const items = Object.values(this.state.items);

            if(items.length === 0){

                this.summaryItems.innerHTML = `
                    <p class="vhb-summary__empty">
                        Seu pedido está vazio.<br>
                        Escolha seus sabores favoritos para começar.
                    </p>
                `;

            }else{

                this.summaryItems.innerHTML = items.map(item=>`

                    <div class="vhb-summary__item">

                        <span class="vhb-summary__item-title">

                            ${item.title}

                        </span>

                        <strong class="vhb-summary__item-qty">

                            ${item.quantity} ${item.quantity > 1 ? 'caixas' : 'caixa'}

                        </strong>

                    </div>

                `).join('');

            }

        }

        if(this.totalItems){

            this.totalItems.textContent =
                this.state.quantity === 1
                    ? '1 caixa'
                    : `${this.state.quantity} caixas`;

        }

        if(this.totalPrice){

            this.totalPrice.textContent =
                this.formatMoney(this.state.subtotal);

        }

        const progressBar =
    document.getElementById("vhb-progress-bar");

const progressText =
    document.getElementById("vhb-progress-text");

const productStep =
    document.getElementById("vhb-step-products");

const shippingStep =
    document.getElementById("vhb-step-shipping");

if(progressBar){

    let width = 8;

    if(this.state.quantity >= 1){

        width = 50;

    }

    if(this.state.quantity >= 2){

        width = 100;

    }

    progressBar.style.width = width + "%";

}

if(productStep){

    productStep.classList.toggle(
        "active",
        this.state.quantity >= 1
    );

}

if(shippingStep){

    shippingStep.classList.toggle(
        "active",
        this.state.quantity >= 2
    );

}

if(progressText){

    if(this.state.quantity === 0){

        progressText.innerHTML =
            "Adicione sua primeira caixa.";

    }else if(this.state.quantity === 1){

        progressText.innerHTML =
            "Você está a apenas <strong>1 caixa</strong> do frete grátis.";

    }else{

        progressText.innerHTML =
            "🚚 <strong>Você desbloqueou o frete grátis!</strong>";

    }

}

    }

    /* ==========================================================
       RENDER SHIPPING
    ========================================================== */

    renderShipping(){

        if(!this.shippingMessage) return;

        if(this.state.quantity === 0){

            this.shippingMessage.innerHTML =
                '🚚 Frete grátis a partir de <strong>2 caixas</strong>.';

            this.shippingMessage.classList.remove('success');

            return;

        }

        if(this.state.quantity < CONFIG.FREE_SHIPPING_QTY){

            const remaining =
                CONFIG.FREE_SHIPPING_QTY - this.state.quantity;

            this.shippingMessage.innerHTML =
                `🎯 Falta apenas <strong>${remaining} ${remaining > 1 ? 'caixas' : 'caixa'}</strong> para liberar o Frete Grátis.`;

            this.shippingMessage.classList.remove('success');

            return;

        }

        this.shippingMessage.innerHTML =
            '🎉 <strong>Frete Grátis Liberado!</strong>';

        this.shippingMessage.classList.add('success');

    }
        /* ==========================================================
       RENDER CART BUTTON
    ========================================================== */

    renderCartButton(){

    if(!this.cartButton) return;

    this.cartButton.disabled = false;

    if(this.state.quantity === 0){

        this.cartButton.textContent =
            'Adicionar ao carrinho';

        this.cartButton.classList.remove(
            'is-checkout'
        );

        return;

    }

    this.cartButton.textContent =
        'Finalizar compra';

    this.cartButton.classList.add(
        'is-checkout'
    );

}

    /* ==========================================================
       GETTERS
    ========================================================== */

    getCartItems(){

        return Object
            .values(this.state.items);

    }

    getCartPayload(){

        return this
            .getCartItems()
            .map(item=>({

                id:Number(item.id),

                quantity:item.quantity

            }));

    }

    /* ==========================================================
       ADD TO CART
    ========================================================== */

    async addToCart(){

        if(this.state.quantity === 0){

            return;

        }

        this.cartButton.disabled = true;

        this.cartButton.textContent =
    'Adicionando ao carrinho...';

        try{

            const payload = {

    items: this.getCartPayload()

};

console.log('Payload:', payload);
console.log(JSON.stringify(payload, null, 2));

console.log('PASSO 1');

// Limpa o carrinho antes de adicionar os novos produtos
await fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
        'Accept': 'application/json'
    }
});

// Aguarda o Shopify finalizar a limpeza
await new Promise(resolve => setTimeout(resolve, 100));

const response = await fetch(

    CONFIG.CART_URL,

    {

        method:'POST',

        headers:{

            'Content-Type':'application/json',

            'Accept':'application/json'

        },

        body:JSON.stringify(payload)

    }

);

            if(!response.ok){

                throw new Error(
                    'Erro ao adicionar produtos.'
                );

            }

            await response.json();
            console.log('PASSO 2');

            this.cartButton.textContent =
    '✓ Produto adicionado';

           setTimeout(() => {

    console.log('PASSO 3');

    // Atualiza o carrinho
    fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {

            console.log('halo:', typeof halo);
console.log('window.halo:', typeof window.halo);
console.log('updateSidebarCart:', window.halo?.updateSidebarCart);

            // Se o tema possui drawer, tenta abrir
            if (
                typeof halo !== 'undefined' &&
                typeof halo.updateSidebarCart === 'function'
            ) {

                halo.updateSidebarCart(cart);

                document.body.classList.add('cart-sidebar-show');

            } else {

    console.log('Produto adicionado ao carrinho.');

    window.location.href = '/checkout';

}

        });

}, 500);

        }catch(error){

            console.error(error);

            this.cartButton.disabled = false;

            this.cartButton.textContent =
    'Ocorreu um erro. Tentar novamente.';

        }

    }
        /* ==========================================================
       DEBUG
    ========================================================== */

    debug(){

        console.clear();

        console.table({

            Produtos:Object.keys(this.state.items).length,

            Quantidade:this.state.quantity,

            Subtotal:this.formatMoney(this.state.subtotal),

            FreteGratis:this.state.freeShipping

        });

    }

    /* ==========================================================
       MICRO ANIMAÇÕES
    ========================================================== */

    animateSummary(){

    if(!this.summary) return;

    this.summary.classList.remove(
        'vhb-summary--updated'
    );

    requestAnimationFrame(()=>{

        this.summary.classList.add(
            'vhb-summary--updated'
        );

    });

    if(this.totalPrice){

        this.totalPrice.classList.remove(
            'vhb-total--pulse'
        );

        requestAnimationFrame(()=>{

            this.totalPrice.classList.add(
                'vhb-total--pulse'
            );

        });

    }

    if(this.totalItems){

        this.totalItems.classList.remove(
            'vhb-total--pulse'
        );

        requestAnimationFrame(()=>{

            this.totalItems.classList.add(
                'vhb-total--pulse'
            );

        });

    }

}

    /* ==========================================================
       OVERRIDE RENDER
    ========================================================== */

    render(){

        this.renderCards();

        this.renderSummary();

        this.renderShipping();

        this.renderCartButton();

        this.animateSummary();

        this.debug();

    }

    /* ==========================================================
       RESET BUILDER
    ========================================================== */

    reset(){

        this.state = {

            items:{},

            quantity:0,

            subtotal:0,

            freeShipping:false

        };

        this.render();

    }

    /* ==========================================================
       DESTROY
    ========================================================== */

    destroy(){

        this.reset();

        this.container = null;

        this.cards = [];

    }

}
/* ==========================================================
   INIT
========================================================== */

document.addEventListener(

    'DOMContentLoaded',

    ()=>{

        const builders = document.querySelectorAll(

            '.vhb-builder'

        );

        if(!builders.length){

            return;

        }

        window.vHydraBuilders = [];

        builders.forEach(builder=>{

            window.vHydraBuilders.push(

                new VHydraBuilder(builder)

            );

        });

    }

);

/* ==========================================================
   GLOBAL HELPERS
========================================================== */

window.VHydraBuilder = {

    get(){

        return window.vHydraBuilders?.[0] || null;

    },

    reset(){

        const builder = this.get();

        if(builder){

            builder.reset();

        }

    },

    items(){

        const builder = this.get();

        if(!builder){

            return [];

        }

        return builder.getCartItems();

    },

    state(){

        const builder = this.get();

        if(!builder){

            return null;

        }

        return builder.state;

    }

};
/* ==========================================================
   CUSTOM EVENTS
========================================================== */

document.addEventListener(

    'vhb:reset',

    ()=>{

        const builder = window.VHydraBuilder.get();

        if(builder){

            builder.reset();

        }

    }

);

document.addEventListener(

    'vhb:refresh',

    ()=>{

        const builder = window.VHydraBuilder.get();

        if(builder){

            builder.render();

        }

    }

);

/* ==========================================================
   DEBUG (DESENVOLVIMENTO)
========================================================== */

if(window.location.hostname === 'localhost'){

    console.log(
        '💜 V-Hydra Builder em modo desenvolvimento'
    );

}

/* ==========================================================
   API PÚBLICA
========================================================== */

window.VHydra = {

    getBuilder(){

        return window.VHydraBuilder.get();

    },

    getItems(){

        return window.VHydraBuilder.items();

    },

    getState(){

        return window.VHydraBuilder.state();

    },

    reset(){

        window.VHydraBuilder.reset();

    }

};
/* ==========================================================
   AUTO START
========================================================== */

window.addEventListener(

    'pageshow',

    ()=>{

        const builder = window.VHydraBuilder.get();

        if(builder){

            builder.render();

        }

    }

);

/* ==========================================================
   FINALIZAÇÃO
========================================================== */

console.log(

    '%cV-Hydra Experience V1.0 carregada com sucesso 💜',

    'color:#6D56F8;font-weight:bold;'

);

document.addEventListener("DOMContentLoaded", () => {

    const hero = document.querySelector("#vhydraHero");
    const toolbar = document.querySelector(".halo-sticky-toolbar-mobile");

    if (!hero || !toolbar) return;

    toolbar.classList.add("vh-hidden");

    const observer = new IntersectionObserver(
        ([entry]) => {

            if (entry.isIntersecting) {
                toolbar.classList.add("vh-hidden");
            } else {
                toolbar.classList.remove("vh-hidden");
            }

        },
        {
            threshold: 0.15
        }
    );

    observer.observe(hero);

});

})(); // Fim da IIFE